import { render, staticRenderFns } from "./FundaIntroE.vue?vue&type=template&id=221b949e&"
import script from "./FundaIntroE.vue?vue&type=script&lang=js&"
export * from "./FundaIntroE.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports